import { useAgentStore } from '@/context/AgentProvider'
import { PropsWithChildren } from 'react'

interface ChatContentContainerProps extends PropsWithChildren {}

const ChatContentContainer = ({ children }: ChatContentContainerProps) => {
  const isChatHistoryOpen = useAgentStore((state) => state.isChatHistoryOpen)
  return <section className={`mp-agent-main ${isChatHistoryOpen ? 'with-chat-history' : ''}`}>{children}</section>
}

export default ChatContentContainer
